import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props} viewBox={'0 0 512 512'}>
        <path fill="#F72585" d="M408 0c-57 0-104 47-104 104 0 22 7 42 18 58L149 273c-16-16-37-25-61-25-49 0-88 39-88 88s39 88 88 88c33 0 62-18 77-45l147 58v3c0 40 32 72 72 72s72-32 72-72-32-72-72-72c-33 0-61 23-69 53l-144-57c3-9 5-18 5-28 0-19-6-37-17-51l173-110c19 20 46 33 76 33 57 0 104-47 104-104S465 0 408 0zm-24 384c31 0 56 25 56 56s-25 56-56 56-56-25-56-56 25-56 56-56zM88 408c-40 0-72-32-72-72s32-72 72-72 72 32 72 72-32 72-72 72zm320-216c-49 0-88-39-88-88s39-88 88-88 88 39 88 88-39 88-88 88z" />
    </svg>
)

export default SvgComponent
